import React, { Component } from "react";
import PendingPatientListItem from "./components/PendingPatientListItem";
import Header from "../Header";
import Menu from "../Menu";
import "../../assets/css/pending-patient-symptom.css";
import { SURGEON } from "../../services/Surgeon";
import DataTable from 'react-data-table-component';

const columns = [
  {
    name: 'ID',
    selector: 'id',
    sortable: true,
  },
  {
    name: 'First Name',
    selector: 'first_name',
    sortable: true,
    right: true,
  },{
    name: 'Narrative Summary',
    selector: 'narrative_summary',
    sortable: true,
    right: true,
  },{
    name: 'Email',
    selector: 'email',
    sortable: true,
    right: true,
  },{
    name: 'Status',
    selector: 'status',
    sortable: true,
    right: true,
  },
];

const pendingPatientsData = [
  {
    "id": 5,
    "first_name": "Mahmood",
    "last_name": "Ahmed",
    "email": "mahmood@ts.com",
    "gender": "Male",
    "narrative_summary": "This is the summary",
    "submitted_by_patient": null,
    "status": 0,
    "exported_file_path": null,
    "via_surgeon_id": 3,
    "department_id": null,
    "created_at": "2019-06-17 15:40:17",
    "updated_at": "2019-06-17 15:40:17"
},
{
    "id": 4,
    "first_name": "Mahmood",
    "last_name": "Ahmed",
    "email": "mahmood@ts.com",
    "gender": "Male",
    "narrative_summary": "This is the summary",
    "submitted_by_patient": null,
    "status": 0,
    "exported_file_path": null,
    "via_surgeon_id": 3,
    "department_id": 2,
    "created_at": "2019-06-17 14:19:38",
    "updated_at": "2019-06-17 14:19:38"
},
];

class PendingPatients extends Component {
  constructor(props) {
    super(props);
    this.state = {
      userData:'',
      pendingPatientsData: pendingPatientsData,
    };
  }

  componentWillMount() {
    let data = localStorage.getItem('userData');
    if(data){
      data = JSON.parse(data);
      this.setState({
        userData: data
      });
    }else{
      this.history.push('/surgeon/login');
    }
  }

  componentDidMount() {
    //send request to api for data
    let LoginResponse = SURGEON.getPendingPatientsNarrative(this.state.userData.user_id)
      .then(res => {
        if (res.data.header.error == 0) {
          this.setState({
            // pendingPatientsData: res.data.header.body.details,
          })
          console.log(this.state.pendingPatientsData);
        } else {
          console.log(res);
        }
      })
      .catch(err => {
        return err;
      });
    }
  
  render() {
    return (
      <React.Fragment>
        <Header
          title="Pending Patient Symptoms"
          titleImage="pending-symptom-img.png"
        />
        <Menu />
        <section className="pending-patient-symptoms">
          <div className="container">
          <DataTable
            columns={columns}
            data={this.state.pendingPatientsData}
          />
            {/* <ul className="patient-symptoms-detail">
              <PendingPatientListItem />
            </ul> */}
          </div>
        </section>
      </React.Fragment>
    );
  }
}

export default PendingPatients;
